import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { SpinnerService } from 'src/app/shared/services/spinner.service';

@Component({
  selector: 'medmio-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {

  constructor(private route:Router,private spinner:SpinnerService,private oauthService:OAuthService
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    setTimeout(() => {
      if(this.oauthService.hasValidAccessToken()){
        this.spinner.hide();
        this.route.navigate(['/main/dashboard'])
      }
      else{
        this.oauthService.initLoginFlow();
      }
    }, 4000);
  }

}
